import React from 'react';
import PropTypes from 'prop-types';
import { vectors } from '../../data/vectors';
import styled from 'styled-components';

const Holder = styled.div`
`;

function EyeBrows({currentAvatar, features, images, path}) {

    return (
      <Holder className={features.haircolour}>
        {/*<img src={images( `${path}_eyebrowshape_${features.eyebrowshape}_shadow.png` )} alt="eyebrow shape shadow"/>*/}
        <img src={images( `${path}_eyebrowshape_${features.eyebrowshape}.png` )} alt="eyebrow shape"/>
        { vectors[`${currentAvatar}_eyebrowshape_${features.eyebrowshape}_vector`] }
      </Holder>
    )
}

EyeBrows.propTypes = {
  features: PropTypes.object,
  images: PropTypes.func,
  path: PropTypes.string,
  currentAvatar: PropTypes.string.isRequired,
};

export default EyeBrows;
